module.exports = "/assets/data/619e8fde13061db0f5815ea5ac4e1eec-JE2.data.json";